import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { MapPinIcon } from 'images/inline-svg';
import { compose, withProps } from 'recompose';
import { GOOGLE_MAP_LINK } from 'data/constants';
import { defaultCoordinates, defaultMapStyle } from 'data/page-data/map-data';

const CustomMap = compose(
  withProps({
    googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDjicr_9-A-_OsFs5tgBzq9S7cAlOssb_Q&language=en',
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: 609 }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,
)(
  (): JSX.Element => {
    const redirectToGoogleMap = () => window.open(GOOGLE_MAP_LINK, '_blank');

    return (
      <GoogleMap
        zoom={9}
        center={defaultCoordinates}
        defaultOptions={{
          // @ts-ignore
          styles: defaultMapStyle,
          fullscreenControl: true,
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: true,
          streetViewControl: false,
          rotateControl: false,
        }}
      >
        <Marker position={defaultCoordinates} icon={MapPinIcon} onClick={redirectToGoogleMap} />
      </GoogleMap>
    );
  },
);
export default CustomMap;
